var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-overlay',{attrs:{"show":_vm.loading}},[_c('div',{ref:"editor"})])}
var staticRenderFns = []

export { render, staticRenderFns }